const zh = Object.freeze({
  brand: Object.freeze({
    subtitle: "华夏版 · Chinese Cultural Edition",
  }),

  nav: Object.freeze({
    home: "首页",
    form: "信息录入",
  }),

  language: Object.freeze({
    zh: "中文",
    en: "EN",
  }),

  landing: Object.freeze({
    eyebrow: "Life Blueprint · 华夏版",
    heroTitlePrefix: "看懂自己的",
    heroTitleHighlight1: "人生模式",
    heroTitleMiddle: "建立更清晰的",
    heroTitleHighlight2: "人生规划",
    heroSubtitle: "Personal Life Blueprint Report · 个人生命蓝图报告",
    heroDescriptionLine1: "结合中华传统分析框架与现代个人规划方法，",
    heroDescriptionLine2: "把结构化洞察整理成清晰重点、行动方向与可执行的下一步。",
    start: "开始我的人生蓝图",
    viewReport: "查看我的报告",
    disclaimer: "本系统内容以传统文化与个人规划参考为主，不构成投资、医疗、法律或任何结果保证。",
    reportSectionsLabel: "正式分析区块",
    section1: "命理核心",
    section2: "六项指数",
    section3: "事业与岗位",
    section4: "个人策略",
    section5: "年度建议",
    section6: "发展方位",
    section7: "号码使用建议",
    section8: "90天行动计划",
    section9: "财富行动蓝图",
    reportSectionsDescription: "九个权威分析区块共同组成您的 Life Blueprint 个人报告。",

    commercialEyebrow: "Life Blueprint 产品",
    commercialTitle: "把传统文化洞察转化为可执行的人生规划",
    commercialDescription: "首先使用 Personal Life Blueprint Report。AI-Guided Interpretation 将作为未来可选的报告解读层推出。",

    reportProductLabel: "核心产品",
    reportProductTitle: "Personal Life Blueprint Report",
    reportProductStatus: "现已提供",
    reportProductDescription: "根据个人资料生成的结构化 Life Blueprint 报告，通过九个分析区块帮助您更清晰地规划方向与行动。",
    reportBenefit1: "个性化 Life Blueprint",
    reportBenefit2: "9 个结构化报告区块",
    reportBenefit3: "事业与岗位方向",
    reportBenefit4: "个人策略与年度重点",
    reportBenefit5: "发展方位与号码使用建议",
    reportBenefit6: "90天行动计划与财富行动蓝图",
    reportBenefit7: "支持中文或英文",
    reportProductCta: "创建我的 Life Blueprint",

    aiProductLabel: "可选解读层",
    aiProductTitle: "AI-Guided Interpretation",
    aiProductStatus: "即将推出",
    aiProductDescription: "用于帮助理解已经生成的 Life Blueprint 正式报告，并把报告重点进一步转化为实际行动。",
    aiBenefit1: "解释和澄清已生成报告中的重点",
    aiBenefit2: "根据正式报告整理当前优先事项",
    aiBenefit3: "把90天行动计划进一步拆分为实际下一步",
    aiProductBoundary: "AI-Guided Interpretation 只负责解释已生成的正式报告，不会重新计算、取代或推翻 Life Blueprint 的正式结果。",

    feature1Title: "命理核心与六项指数",
    feature1Desc: "从命理核心出发，结合六项指数与事业岗位适配，看清当前阶段侧重。",
    feature2Title: "策略与年度规划",
    feature2Desc: "个人策略、年度建议与发展方位，帮助规划更清晰的方向。",
    feature3Title: "号码与财富行动",
    feature3Desc: "号码使用建议、90天行动计划与财富行动蓝图，让规划可执行。",
    footerBrand: "© Life Blueprint · 人生蓝图",
    footerNote: "仅供个人规划参考",
  }),

  form: Object.freeze({
    eyebrow: "Step 01 · 基本信息",
    title: "输入您的基本信息",
    introBeforeBrand: "以下信息用于生成您的 ",
    introAfterBrand: " 个人报告。本流程不涉及任何账户注册，所有数据仅保存在您本机浏览器中。",

    samplePicker: "快速试用：选择一个示例档案",
    sampleA: "示例 A · 张明",
    sampleB: "示例 B · 李雨欣",
    sampleC: "示例 C · 陈家豪",

    name: "姓名",
    namePlaceholder: "例如：张明",
    birthDate: "出生日期",
    birthTime: "出生时辰（参考）",
    birthTimePlaceholder: "选择时辰（仅供参考）",
    birthTimeExact: "精确出生时间（必填）",
    birthTimeExactHint: "V2.9.9 正式报告必须填写 HH:MM；上方出生时辰仅供参考，不参与正式计算。",

    currentGoal: "当前目标",
    currentGoalPlaceholder: "请选择当前目标",
    referenceYear: "参考年份",
    referenceYearPlaceholder: "请明确填写参考年份",
    productionFieldsHint: "以上字段用于生成正式的 Life Blueprint 分析报告。留空表示信息尚未填写完整，系统不会自动采用当前年份或默认目标。",

    gender: "性别",
    genderMale: "男",
    genderFemale: "女",

    region: "当前居住国家/地区",
    regionPlaceholder: "请选择当前居住国家/地区",

    disclaimer: "本报告依据传统文化规则生成，仅供参考。本内容不构成投资、医疗、法律或任何结果保证。",

    submit: "生成我的人生蓝图",
    reset: "清空",

    missingTitle: "请完成所有信息后再提交",
    missingProduction: "请填写：姓名、出生日期、精确出生时间（HH:MM）、性别、当前居住国家/地区、当前目标和参考年份。",
    missingMock: "请完成所有必填字段后再生成完整的人生蓝图。",
    persistenceTitle: "报告保存失败",
    persistenceDescription: "分析已完成，但结果未能完整保存到本机浏览器。请检查浏览器储存空间或权限后重试。",
    engineErrorTitle: "报告生成失败",
    engineErrorPrefix: "未能生成报告：",
    unknownError: "未知错误",
    successTitle: "蓝图已生成",
    successDescription: "正在前往您的个人总览…",
    sampleAppliedTitle: "已填入示例数据",
    sampleAppliedDescription: "点击「生成我的人生蓝图」查看个性化结果。",

    birthZi: "子时 (23:00-01:00)",
    birthChou: "丑时 (01:00-03:00)",
    birthYin: "寅时 (03:00-05:00)",
    birthMao: "卯时 (05:00-07:00)",
    birthChen: "辰时 (07:00-09:00)",
    birthSi: "巳时 (09:00-11:00)",
    birthWu: "午时 (11:00-13:00)",
    birthWei: "未时 (13:00-15:00)",
    birthShen: "申时 (15:00-17:00)",
    birthYou: "酉时 (17:00-19:00)",
    birthXu: "戌时 (19:00-21:00)",
    birthHai: "亥时 (21:00-23:00)",
    birthUnknown: "不确定 / 未知",

    regionMalaysia: "马来西亚",
    regionSingapore: "新加坡",
    regionMainlandChina: "中国大陆",
    regionHongKong: "香港特别行政区",
    regionMacao: "澳门特别行政区",
    regionTaiwan: "台湾",
    regionOtherAsia: "亚洲其他地区",
    regionEurope: "欧洲",
    regionNorthAmerica: "北美洲",
    regionOceania: "大洋洲",
    regionMiddleEast: "中东",
    regionOther: "其他",

    // Legacy labels retained for backward-compatible rendering.
    regionEastChina: "华东地区",
    regionNorthChina: "华北地区",
    regionSouthChina: "华南地区",
    regionCentralChina: "华中地区",
    regionSouthwestChina: "西南地区",
    regionNorthwestChina: "西北地区",
    regionNortheastChina: "东北地区",
    regionHmt: "港澳台地区",
    regionOverseas: "海外地区",

    goalComprehensive: "综合分析",
    goalCareer: "事业发展",
    goalWealth: "财富增长",
    goalEntrepreneurship: "创业发展",
    goalLearning: "学习提升",
    goalCollaboration: "贵人合作",
    goalStability: "稳定生活",
    goalBrand: "个人品牌",
    goalSales: "销售沟通",
    goalContent: "内容创作",
    goalLeadership: "管理领导",
    goalClientRelations: "客户关系",
  }),


  commercial: Object.freeze({
    eyebrow: "安全付款",
    title: "解锁您的 Life Blueprint 报告",
    description: "先建立安全付款订单，在 Billplz 完成付款。本页面会依据服务器确认的付款状态决定是否开放报告。",
    name: "客户姓名",
    email: "电子邮箱",
    creating: "正在建立付款订单…",
    createCheckout: "前往安全付款",
    awaitingPayment: "等待付款确认",
    checkingStatus: "正在确认付款状态…",
    openPayment: "打开 Billplz 付款页面",
    checkAgain: "重新检查付款状态",
    checkoutEnded: "本次付款流程已结束",
    startNewCheckout: "重新建立付款订单",
    ambiguousWarning: "目前无法确定支付平台是否已经建立账单。请勿再次付款；请稍后重新检查或联系支持。",
    paymentConfirmed: "付款已确认",
    entitlementActive: "您的付费报告权限已经启用，现在可以继续填写个人资料。",
    continueToProfile: "继续填写资料",
    checkingAccess: "正在验证付费访问权限…",
    createError: "暂时无法建立付款订单，请稍后重试。",
    statusError: "暂时无法确认付款状态，请稍后重试。",
    authorityNote: "只有服务器确认订单为 PAID 且 entitlement 为 ACTIVE 后才会开放报告。仅从付款页面返回并不代表付款成功。",
  }),

  dashboard: Object.freeze({
    loading: "加载中…",

    eyebrow: "Life Blueprint · 个人总览",
    title: "我的 Life Blueprint",
    profileOverview: "个人总览",
    sampleUser: "示例用户",
    profileLabel: "档案",

    reportReady: "报告已验证",
    reportUnavailable: "报告暂不可用",
    sampleResult: "示例结果",
    editProfile: "重新填写",
    downloadPdf: "下载 PDF",
    pdfPreparing: "正在准备 PDF…",
    pdfDownloadFailed: "PDF 下载失败，请稍后重试。",

    defaultNoticeBefore: "当前展示的是默认示例档案。请先前往",
    defaultNoticeLink: "信息录入页",
    defaultNoticeAfter: "填写您的资料，以查看个性化蓝图。",

    summaryTitle: "总览摘要",
    overviewTitle: "人生蓝图概览",
    overviewNote: "本图为综合能量分布示意，六大维度用于快速判断当前阶段侧重。实际权重与算法将在正式 Life Blueprint 计算引擎中确定。",

    themesTitle: "12 个主题分析",
    strength: "强度",

    numbersTitle: "24 号码建议",
    favorableNumbers: "多用号码",
    cautionaryNumbers: "少用号码",
    usage: "使用说明",
    numbersNote: "号码建议为示例内容。请把它作为参考信号，不作为唯一决策依据。",

    wealthTitle: "个人财富行动蓝图",
    wealthFocus: "当前重点",
    wealthPriority: "优先行动",
    wealthWatch: "建议关注",
    wealthNext: "下一步规划",

    failclosedTitle: "报告暂不可用",
    failclosedMessage: "尚未找到有效的生产报告，请重新填写资料并生成 Life Blueprint。",
    failclosedButton: "前往信息录入页",

    footerBrand: "© Life Blueprint · 人生蓝图",
    footerBrandSample: "© Life Blueprint · 人生蓝图 · 示例模式",
    footerProductionNote: "传统文化与个人规划参考 · 不构成投资、医疗或法律建议",
    footerSampleNote: "示例结果 · 不构成投资、医疗或法律建议",

    themeDetail: "主题详情",
    energyStrength: "能量强度",
    themeSampleNote: "本主题分析为示例结果，正式报告以 Life Blueprint 生产规则为准。",
  }),


  report: Object.freeze({
    profileTitle: "客户档案",
    name: "姓名",
    birthDate: "出生日期",
    gender: "性别",
    region: "当前居住国家/地区",
    exactBirthTime: "精确出生时间",

    planningContext: "业务背景",
    currentGoal: "当前目标",
    referenceYear: "参考年份",

    sectionCore: "命理核心",
    sectionIndices: "六项指数",
    sectionCareer: "事业与岗位",
    sectionStrategy: "个人策略",
    sectionAnnual: "年度建议",
    sectionDirection: "发展方位",
    sectionNumber: "号码使用建议",
    sectionActionPlan: "90天行动计划",
    sectionWealth: "财富行动蓝图",

    fourPillars: "四柱八字",
    dayMaster: "日主",
    dayMasterStrength: "日主状态",
    strengthScore: "强弱分数",
    neededElement: "五行需求",
    seasonalSupport: "得令",
    rootSupport: "得地",
    peerSupport: "得助",

    indexCareerFit: "事业适配",
    indexWealth: "财富发展",
    indexVenture: "创业适配",
    indexLearning: "学习提升",
    indexNetwork: "贵人合作",
    indexStability: "稳定生活",

    topIndustries: "首选行业",
    topRoles: "首选岗位",

    strategyCorePosition: "核心定位",
    strategyCorePositionExplanation: "定位说明",
    strategyCareerStrategy: "事业策略",
    strategyCareerAction: "事业行动",
    strategyWealthStrategy: "财富策略",
    strategyWealthAction: "财富行动",
    strategyVentureFeasibility: "创业可行性",
    strategyLearningGrowth: "学习成长",
    strategyMentorCooperation: "贵人合作",
    strategyStableLife: "稳定生活",
    strategyAnnualFocus: "年度重心",
    strategyRiskAlert: "风险提示",
    strategyResponseAdvice: "应对建议",
    strategyAvoidItems: "需避免",
    strategySummaryAdvice: "综合建议",

    annualTitle: "年度主题",
    annualSuitableActions: "适宜行动",
    annualActionsToAvoid: "应避免行动",
    annualCareerAdvice: "事业建议",
    annualWealthRhythm: "财富节奏",
    annualLearningAdvice: "学习建议",
    annualRelationshipAdvice: "人际建议",
    annualVentureCareerAdvice: "创业事业建议",
    annualActionList: "年度行动清单",
    annualWeaknessDescription: "弱项描述",
    annualElementCareerAdvice: "五行事业建议",
    annualElementWealthAdvice: "五行财富建议",

    directionTopDevelopment: "首选发展方位",
    directionSecondaryDevelopment: "次选发展方位",
    directionReduceDevelopment: "宜减少方位",
    directionPrimary: "主方位",
    directionSecondary: "次方位",
    directionReduce: "减少方位",
    directionRecommendedIndustries: "推荐行业",
    directionRecommendedRoles: "推荐岗位",
    directionSuitableEnvironment: "适宜环境",
    directionUnsuitableEnvironment: "不宜环境",
    directionCareerAdvice: "事业建议",
    directionWealthAdvice: "财富建议",
    directionVentureAdvice: "创业建议",
    directionParallelWarning: "并列提示",
    directionIntegratedConclusion: "综合结论",

    numberCoreBasis: "核心依据",
    numberElementMeaning: "五行含义",
    numberLifeSummary: "生命数字",
    numberLifeNumberRaw: "生命数字原值",
    numberLifeElement: "生命数字五行",
    numberRuleDigest: "规则摘要",
    numberOverallRelation: "整体关系",
    numberBoundaryHint: "边界提示",
    numberCoreBlock: "核心号码",
    numberAuxBlock: "辅助号码",
    numberLifeBlock: "生命数字号码",
    numberCombinationStructure: "组合结构",
    numberPriorityOrder: "优先顺序",
    numberReinforcementLogic: "强化逻辑",
    numberLifeUsage: "生命数字用法",
    numberReduceBlock: "少用号码",
    numberReduceRelation: "少用关系",
    numberLifeOverlap: "生命数字重叠",
    numberReduceBoundary: "少用边界",
    numberMobileAdvice: "手机号建议",
    numberVehicleAdvice: "车牌建议",
    numberDoorAdvice: "门牌建议",
    numberAccountAdvice: "账号建议",
    numberSummaryUsage: "使用总结",
    numberIntegratedRecommendation: "综合建议",

    personalYear: "个人流年",
    actionCurrentGoal: "当前目标",
    phase30: "30天",
    phase60: "60天",
    phase90: "90天",
    dayMasterNote: "日主状态提醒",
    annualRiskNote: "年度风险提示",
    actionPlanSourceUnavailable: "当前验证数据源未提供「综合分析」对应的独立90天行动项。",

    wealthPersonality: "财富人格",
    wealthIncomeTendency: "收入倾向",
    wealthIncomeStructureAdvice: "收入结构建议",
    wealthStrongestSummary: "最强能力",
    wealthPriorityReinforcement: "优先补强",
    wealthStageConclusion: "阶段结论",
    wealthRecommendedModeDetail: "推荐模式",
    wealthAnnualRhythmDetail: "年度节奏",
    wealthGuiRenResource: "贵人资源",
    wealthRiskToleranceDetail: "风险承受",
    wealthDay30Plan: "30天计划",
    wealthDay60Plan: "60天计划",
    wealthDay90Plan: "90天计划",
    wealthNumberCulture: "号码文化参考",
    wealthIntegratedPriority: "综合优先级",

    editProfile: "重新填写资料",
  }),

});

export default zh;
